export default {
  Confirm: 'Conferma',
  Cancel: 'Annulla',
  'The minimum time length is xxxs!': 'La durata minima è {{num}}s!',
  'The maximum time length is 50s!': 'La durata massima è 50s!',
  'Online service, no download required': 'Servizio online, nessun download richiesto.',
  'Add up to 20MB file': 'Aggiunge fino a 20 MB di file',
  'Support common formats': 'Supporta formati comuni',
  'Best for general editing requirements': 'Ideale per requisiti di editing generali.',
  '0 second wait': '0 secondi di attesa',
  'No size limits': 'Nessun limite di dimensione',
  'Support 1000+ formats': 'Supporta oltre 1000 formati',
  'Stable processing': 'Elaborazione stabile',
  'Get access to HitPaw Toolkit!': 'Accedi a HitPaw Toolkit!',
  'Support cut, crop & rotate, adjust, speed, add music, stop motion, etc.':
    "Supporta il taglio, il ritaglio e la rotazione, la regolazione, la velocità, l'aggiunta di musica, stop-motion, ecc.",
  'The easiest video editing software for beginners':
    'Il software di editing video più semplice per i principianti',
  'Remove watermark from videos and images in simple clicks':
    'Rimuove la filigrana da video e immagini con semplici clic',
  'TRY IT FREE': 'PROVALO GRATIS',
  'BUY NOW': 'ACQUISTA ORA',
  'Analyzing successfully! Your file is larger than 100 MB which cannot be edited by HitPaw Online, please ':
    'Analisi riuscita! Il file supera i 100 MB pertanto non può essere modificato da HitPaw Online, si prega di ',
  'download the video': 'scaricare il video',
  'and then use HitPaw Toolkit to proceed.': ' e quindi usare HitPaw Toolkit per procedere.',
  'Cut 10 video fragments at most. Get HitPaw Toolkit for more features.':
    'Taglia 10 frammenti video al massimo. Ottieni HitPaw Toolkit per più funzionalità.',
  'Max file size for videos is 20 MB. Get HitPaw Toolkit for big file.':
    'La dimensione del file non può essere oltre 20MB. Ottieni HitPaw Toolkit per più funzionalità.',
  'The minimum time length is 1s! Get HitPaw Toolkit for more features.':
    'La durata minima è 1s! Ottieni HitPaw Toolkit per più funzionalità.',
  'Add 3 videos at most. Get HitPaw Toolkit for more features.':
    'Aggiungi 3 video al massimo. Ottieni HitPaw Toolkit per più funzionalità.',
  'This format is not supported currently.': 'Questo formato non è al momento supportato.',
  'This format is not supported currently. Get HitPaw Toolkit for more formats':
    'Questo formato non è al momento supportato. Ottieni HitPaw Toolkit per più funzionalità.',
  'Processing failed. Get HitPaw Toolkit for stable processing.': 'Generazione Video Non Riuscita!',
  'Failed to load!  Get HitPaw Watermark Remover for stable processing.':
    'Caricamento non riuscito!',
  'Are you sure you want to delete it?': 'Sei sicuro di volerlo eliminare?',
  'Failed to extract the audio!': "Impossibile estrarre l'audio!",
  'Coming Soon': 'A Breve',
  'Learn more': 'Ulteriori Informazioni',
  'Add up to 2 files. Get HitPaw Toolkit for big file.':
    'Aggiunge fino a 2 fili. Ottieni HitPaw Toolkit per più funzionalità.',
  Download: 'Scarica',
  'Try Again': 'Riprova',
  Failed: 'Fallito',
  'Get Started': 'Inizia a Modificare',
  Start: 'Inizia',
  End: 'Fine',
  Export: 'Esporta',
  'Your audio is ready!': 'Il tuo audio è pronto!',
  'Download Audio': 'Scarica audio',
  YES: 'SÌ',
  'Export Failed': 'Esportazione non riuscita',
  'Error occurs, the file cannot be added':
    'Si verifica un errore, il file non può essere aggiunto',
  'Support merging audio files at most': "Supporta l'unione di {{num}} file audio al massimo",
  'Are you sure you want to delete this task?': 'Sei sicuro di voler eliminare questa attività?',
  Processing: 'Elaborazione in corso',
  "Don't forget to download your file, it will be deleted after 24 hours.":
    'Non dimentica di scaricare il tuo file, sarà abbondato 24 ore dopo.',
  Uploading: 'Caricamento in corso',
  'Go Edit': 'Vai a modificare',
  'Generate Files Successfully!': 'Generazione File Riuscita!',
  'Your order is being paid...': 'Il tuo ordine è stato pagato',
  'Not yet': 'Non ancora',
  'Payment completed': 'sì',
  downloadFail: 'Failed to download, please try again.',
  videoReady: 'Your animated photo is ready!',
  'Download Without Watermark': 'Download Without Watermark',
  'Download As GIF': 'Download As GIF',
  'Download With Watermark': 'Download With Watermark',
  'Upload New Photo': 'Upload New Photo',
  ///////////
  'Upgrade to access HitPaw Online Pro Features.': 'Upgrade to access HitPaw Online Pro Features.',
  'Free account cannot upload image size that exceeds 2M.':
    'Free account cannot upload image size that exceeds 2M.',
  'Free account cannot upload more than 6 images.':
    'Free account cannot upload more than 6 images.',
  'No Image Size Limits': 'No Image Size Limits',
  'Unlimited Image Uploads': 'Unlimited Image Uploads',
  'Download HD Image with No Watermark': 'Download HD Image with No Watermark',
  'Download Video as GIF': 'Download Video as GIF',
  'More Privileges': 'More Privileges',
  Monthly: 'Monthly',
  Yearly: 'Yearly',
  'Cancel auto-renewable subscription anytime.': 'Cancel auto-renewable subscription anytime.',
  'Login to Start': 'Login to Start',
  'Buy Now': 'Buy Now',
  'Network Error': 'Network Error',
  'Connection server failed.': 'Connection server failed.',
  Month: 'Month',
  priceMonth: '$9.99',
  priceYear: '$4.99',
  'HitPaw Video Converter': 'HitPaw Video Converter',
  'The upload video size cannot exceed 20MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 20MB. Download HitPaw Video Converter for more features.',
  'The upload video size cannot exceed 500MB. Download HitPaw Video Converter for more features.': 'The uploaded video size cannot exceed 500MB. Download HitPaw Video Converter for more features.',
  'The upload image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.':  'The uploaded image resolution cannot exceed 16 megapixel. Download HitPaw Video Converter for more features.',
  'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.': 'The batch processing function is only available in the desktop software. Download HitPaw Video Converter for more features.',
  'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.': 'The number of files you processed today has reached the upper limit of 300. Download HitPaw Video Converter for more features.',
  'Download desktop version to batch process large files with no size limit': 'Download desktop version to batch process large files with no size limit',
  'Batch convert video and audio files to 1000+ formats with 120X faster speed': 'Batch convert video and audio files to 1000+ formats with 120X faster speed',
  'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.': 'Download and save videos from 10000+ websites, such as YouTube, TikTok, Instagram, etc.',
  'Built-in rich video editing features: merge, cut, crop, watermark, etc.': 'Built-in rich video editing features: merge, cut, crop, watermark, etc.',
  'Convert Apple Music to MP3 with DRM removed (Windows version only)': 'Convert Apple Music to MP3 with DRM removed (Windows version only)',
}
